export const breakPoint = {
  IPAD_PRO: 1024,
}
